import React from 'react'
import { B2Sunrise } from '@e3dc-react/icons'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Button, Typography } from '@mui/material'
import { Box } from '@mui/system'
import { useNavigate, Outlet } from 'react-router-dom'
import { useFeatureFlagsContext } from 'src/Libs/feature-flags/FeatureFlagsContext'
import { makeStyles } from 'tss-react/mui'
import { SuspenseContentFallback } from '@e3dc-react/shell/Elements/Suspense'

const useStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    minHeight: '80vh',
  },
  image: {
    width: '75px',
    height: '75px',
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(4),
  },
  title: {
    marginBottom: theme.spacing(2),
  },
  button: {
    marginTop: theme.spacing(2),
  },
}))

/*
 * Maintenance Page when Shop its on maintenance mode.
 */
const ShopMaintenance: React.FC = () => {
  const { featureFlags, isFeatureFlagsLoading } = useFeatureFlagsContext()
  const { isShopMaintenanceModeEnabled } = featureFlags
  const navigate = useNavigate()
  const reload = (): void => navigate(0)
  const { classes } = useStyles()
  const { t } = useCustomTranslation()

  if (isFeatureFlagsLoading) return <SuspenseContentFallback />

  if (isShopMaintenanceModeEnabled) {
    return (
      <Box className={classes.container}>
        <Box>
          <B2Sunrise className={classes.image} />
          <Typography variant="h2" className={classes.title}>
            {t('shop.maintenance.title')}
          </Typography>
          <Typography>{t('shop.maintenance.subtitle')}</Typography>
          <Typography>{t('shop.maintenance.info')}</Typography>
          <Button onClick={reload} variant="contained" className={classes.button}>
            {t('shop.maintenance.reload-button')}
          </Button>
        </Box>
      </Box>
    )
  }

  return <Outlet />
}
export default ShopMaintenance
